var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.content.type === 'text')?_c('text-block',{attrs:{"content":_vm.content.content,"footnote":_vm.content.footnote,"quote":_vm.content.quote,"isTitle":_vm.content.isTitle}}):_c('image-block',{attrs:{"content":_vm.content.content}})}
var staticRenderFns = []

export { render, staticRenderFns }